module.exports = __webpack_public_path__ + "static/media/LockLogo_Horizontal_White.f746a14b.png";